module.exports = __webpack_public_path__ + "img/K.c9006f2c.png";